export function validatePreserveProfit(data) {
  if (Number(data.activationProfitAmount) < Number(data.amount)) {
    return [false, 'Activation amount is smaller than preserve amount.'];
  } else if (data.amount <= 0) {
    return [false, 'Preserve amount is less than or equal to zero.'];
  }
  return [true, ''];
}
